import {
    CustomSeriesPricePlotValues,
    ICustomSeriesPaneView,
    PaneRendererCustomData,
    Time,
    WhitespaceData
} from 'lightweight-charts'
import { defaultOptions, FillSeriesOptions } from './options'
import { FillSeriesRenderer } from './renderer'
import { FillData } from './data'

export class FillSeries<TData extends FillData>
    implements ICustomSeriesPaneView<Time, TData, FillSeriesOptions> {
    _renderer: FillSeriesRenderer<TData>

    constructor() {
        this._renderer = new FillSeriesRenderer()
    }

    priceValueBuilder(plotRow: TData): CustomSeriesPricePlotValues {
        return [plotRow.high, plotRow.low]
    }

    isWhitespace(data: TData | WhitespaceData): data is WhitespaceData {
        return (data as Partial<TData>).low === undefined
    }

    renderer(): FillSeriesRenderer<TData> {
        return this._renderer
    }

    update(
        data: PaneRendererCustomData<Time, TData>,
        options: FillSeriesOptions
    ): void {
        this._renderer.update(data, options)
    }

    defaultOptions() {
        return defaultOptions
    }
}
